import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { useTranslation } from 'react-i18next';

export const Header = ({ onBookClick }) => {
  const { t } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-neutral-900/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img
              src="https://customer-assets.emergentagent.com/job_kamotors/artifacts/1wvd6bp4_logg.jpeg"
              alt="K&A Motors Tech Solutions"
              className="h-16 w-16 object-contain"
            />
            <div>
              <h1 className="text-xl font-bold text-white">K&A Motors Tech Solutions</h1>
              <p className="text-xs text-lime-400">Electronic Diagnostics Experts</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('services')}
              className="text-neutral-200 hover:text-lime-400 transition-colors font-medium"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-neutral-200 hover:text-lime-400 transition-colors font-medium"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('reviews')}
              className="text-neutral-200 hover:text-lime-400 transition-colors font-medium"
            >
              Reviews
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-neutral-200 hover:text-lime-400 transition-colors font-medium"
            >
              Contact
            </button>
          </nav>

          {/* CTA Buttons */}
          <div className="hidden md:flex items-center space-x-4">
            <Button
              onClick={onBookClick}
              className="bg-lime-500 hover:bg-lime-600 text-neutral-900 font-bold px-6 py-2 transition-all duration-300 hover:scale-105"
            >
              {t('btn_book')}
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-white p-2"
          >
            {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-neutral-900 border-t border-neutral-800">
          <nav className="flex flex-col px-4 py-4 space-y-4">
            <button
              onClick={() => scrollToSection('services')}
              className="text-neutral-200 hover:text-lime-400 transition-colors font-medium text-left"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-neutral-200 hover:text-lime-400 transition-colors font-medium text-left"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('reviews')}
              className="text-neutral-200 hover:text-lime-400 transition-colors font-medium text-left"
            >
              Reviews
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-neutral-200 hover:text-lime-400 transition-colors font-medium text-left"
            >
              Contact
            </button>
            <Button
              onClick={() => {
                onBookClick();
                setIsMobileMenuOpen(false);
              }}
              className="bg-lime-500 hover:bg-lime-600 text-neutral-900 font-bold w-full"
            >
              Book Appointment
            </Button>
          </nav>
        </div>
      )}
    </header>
  );
};
